import React from 'react';
import PropTypes from 'prop-types';

import SafeDeleteInstancePage from '../components/App/SafeDeleteInstance/SafeDeleteInstancePage';

const SafeDeleteInstanceRoute = ({ basePath }) => {
  return (
    <SafeDeleteInstancePage
      basePath={basePath}
    />
  );
};

SafeDeleteInstanceRoute.propTypes = {
  basePath: PropTypes.string.isRequired,
};

export default SafeDeleteInstanceRoute;
